const initialState = () => ({
  cronEmail: '',
  cronJobs: []
})

const state = initialState

const getters = {
  cronEmail: state => state.cronEmail,
  cronJobs: state => state.cronJobs.map(job => ({ ...job }))
}

const mutations = {
  SET_CRON_EMAIL: (state, email) => {
    state.cronEmail = email
  },
  SET_CRON_JOBS: (state, jobs) => {
    state.cronJobs = jobs.filter(job => typeof job.linekey !== 'undefined')
  },
  CLEAR_CRON_STORE (state) {
    const s = initialState()

    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  }
}

const actions = {
  // Get current cron email
  async getCronEmail ({ dispatch, commit }, { _username }) {
    const data = {
      api2_module: 'Cron',
      api2_method: 'get_email',
      _username,
    }

    try {
      const response = await dispatch('cpanel_api2', data)
      let email = response.payload.data[0].email
      commit('SET_CRON_EMAIL', email)

      return Promise.resolve(email)
    } catch (e) {
      throw e
    }
  },
  // Set new cron email
  async setCronEmail ({ dispatch, commit }, payload) {
    const data = {
      api2_module: 'Cron',
      api2_method: 'set_email',
      ...payload
    }

    try {
      let query = await dispatch('cpanel_api2', data)
      let email = query.payload.data[0].email

      commit('SET_CRON_EMAIL', email)
    } catch (e) {
      throw e
    }
  },
  // Add new cron line
  async addCronLine ({ dispatch, commit }, { minute, hour, day, month, weekday, command, _username }) {
    const data = {
      api2_module: 'Cron',
      api2_method: 'add_line',
      minute,
      hour,
      day,
      month,
      weekday,
      command,
      _username
    }

    try {
      let query = await dispatch('cpanel_api2', data)
      if (query.payload.data[0].status === 0) {
        return Promise.reject(query.data[0].statusmsg)
      }
    } catch (e) {
      throw e
    }
  },

  // Edit existing cron line
  async editCronLine ({ dispatch, commit }, { minute, hour, day, month, weekday, command, linekey, _username }) {
    const data = {
      api2_module: 'Cron',
      api2_method: 'edit_line',
      linekey,
      minute,
      hour,
      day,
      month,
      weekday,
      command,
      _username
    }

    try {
      let query = await dispatch('cpanel_api2', { ...data })

      if (query.payload.data[0].status === 0) {
        return Promise.reject(query.payload.data[0].statusmsg)
      }
    } catch (e) {
      throw e
    }
  },

  // Remove cron line
  async removeCronLine ({ dispatch }, { line, _username }) {
    const data = {
      api2_module: 'Cron',
      api2_method: 'remove_line',
      line,
      _username,
    }

    try {
      let query = await dispatch('cpanel_api2', data)

      if (query.payload.data[0].status === 0) {
        return Promise.reject(query.payload.data[0].resultmsg)
      }
    } catch (e) {
      throw e
    }
  },

  // Get list of cron jobs
  async getCronJobsList ({ dispatch, commit }, { _username }) {
    const data = {
      api2_module: 'Cron',
      api2_method: 'listcron',
      _username,
    }

    try {
      const response = await dispatch('cpanel_api2', data)
      commit('SET_CRON_JOBS', response.payload.data)
    } catch (e) {
      throw e
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
